/** When your routing table is too long, you can split it into small modules**/

export default [
  {
    path: "/tadris-permission-request",
    name: "permissionRequest",
    component: () => import("@/views/tadris-permission/Request"),
  },
  {
    path: "/tadris-permission-history",
    name: "permissionHistory",
    component: () => import("@/views/tadris-permission/Index"),
  },
];
